var map = {
	"./6-months-project.png": 4038,
	"./algorithms.jpg": 4370,
	"./certificates.jpg": 6584,
	"./cybersecurity.jpeg": 8036,
	"./how-to-design-a-function.jpg": 4674,
	"./how-to-manage-your-dependencies.jpg": 2460,
	"./write-code-not-comments.jpg": 8998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6058;